<template>
  <w-dialog
    :show="visible"
    @close="handleClose"
    show-close
    custom-class="joined-success"
    :box-style="{ width: '320px' }"
    :bodyStyle="{ padding: 0 }">
    <div class="text-align-center relative" style="padding: 44px 34px 40px 34px;">
      <span class="close" @click="handleClose">
        <i class="r2-icon-nav_close"></i>
      </span>
      <div class="text-align-center" style="height: 72px;">
        <div class="inline-block" style="width: 72px; height: 72px; background: #00c461; border-radius: 50%;">
          <i class="r2-icon-nav_check inline-block color-white" style="font-size: 48px;"></i>
        </div>
      </div>
      <div style="height: 32px; font-size: 24px; font-weight: 500; color: #212530; line-height: 32px; margin-top: 32px;">成功加入 </div>
      <div style="margin: 16px 0 37px 0; color: rgba(33, 37, 48, 0.55);">成功获得企业身份，请注意查收短信</div>
      <div>
        <w-button size="small" type="primary" @click="handleLogin()">立即登录</w-button>
      </div>
    </div>
  </w-dialog>
</template>

<script>
export default {
  name: 'JoinedSuccess',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 取消
    handleClose () {
      this.$emit('close')
    },
    // 去登录
    handleLogin () {
      this.$emit('login')
    }
  }
}
</script>

<style lang="less">
  .joined-success {
    .close {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 12px;
      top: 12px;
      cursor: pointer;
      i {
        color: rgba(33, 37, 48, 0.55);
      }
      &:hover {
        i {
          color: #000000;
        }
      }
    }
  }
</style>
